import { AuthService } from '@/services';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useInitForgotPasswordMutation = (
  options: UseMutationOptions<
    { data: { email: string; tenantId: string; challenge: string } },
    Error,
    unknown,
    unknown
  >,
) => {
  const mutation = useMutation({
    mutationFn: AuthService.initForgotPassword,
    ...options,
  });

  return mutation;
};
